import React, {useEffect} from 'react'
import {useIntl} from 'react-intl'
import {CSSTransition} from 'react-transition-group'
import {useAuth} from '../../auth'
import {toAbsoluteUrl} from '../../../../_gori/helpers'
import {STEPS} from '../core/_const'

type Props = {
  setActiveStep: any
}

const Welcome: React.FC<Props> = ({setActiveStep}) => {
  const intl = useIntl()
  const {currentUser} = useAuth()

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep(STEPS.pricing)
    }, 5000)
    return () => clearInterval(interval)
  }, [setActiveStep])

  const getUserName = () =>
    currentUser?.first_name || currentUser?.last_name
      ? `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim()
      : ''

  return (
    <CSSTransition appear in timeout={300} classNames='fade' unmountOnExit>
      <div className='welcome text-center'>
        <img
          alt='welcome'
          src={toAbsoluteUrl('/media/gori/onboard/welcome/solution_motion_image.gif')}
          className='welcome-img'
        />
        <p>
          {getUserName()
            ? intl.formatMessage({id: 'WELCOME'}) + ' ' + getUserName()
            : intl.formatMessage({id: 'WELCOME'}) + '!'}
          <img
            alt='welcome'
            src={toAbsoluteUrl('/media/gori/onboard/welcome/party-popper.png')}
            className='partypopper'
          />
        </p>
      </div>
    </CSSTransition>
  )
}

export {Welcome}
